import DSW from './src/main'
import { addComponent } from '~/utils/helper'

export default addComponent(DSW)


// WEBPACK FOOTER //
// ./public/dsw/index.js